import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
import type { SlideProps } from './SlideShell';
export function Slide01Title({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-black" data-id="element-34">
      {/* Hero image with cinematic overlay */}
      <div className="absolute inset-0" data-id="element-35">
        <motion.img src="https://images.unsplash.com/photo-1631563019676-dade0dbdb8fc?w=1920&q=80" alt="African doctor consulting with a patient" className="w-full h-full object-cover opacity-80" initial={{
        scale: 1.08
      }} animate={{
        scale: 1
      }} transition={{
        duration: 8,
        ease: 'easeOut'
      }} data-id="element-36" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" data-id="element-37" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-38" />
      </div>

      {/* Top brand accent */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-2 bg-[var(--brand)] origin-left z-20" data-id="element-39" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-40">
        <div className="max-w-4xl" data-id="element-41">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-42">
            <span className="h-px w-12 bg-[var(--brand-lighter)]" data-id="element-43" />
            <p className="text-[var(--brand-lighter)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-bold uppercase tracking-[0.25em]" data-id="element-44">
              Proposal
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-white font-bold text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-45">
            Roche Ivory Coast –<br data-id="element-46" />
            <span className="text-[var(--brand-lighter)]" data-id="element-47">
              Partnering to Deliver
            </span>
          </motion.h1>

          {/* Subline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="text-white/90 text-[clamp(1.1rem,1.8vw,1.6rem)] font-medium max-w-3xl leading-snug mb-[clamp(2rem,4vw,3rem)]" data-id="element-48">
            Your execution partner for high-impact HCP campaigns across the
            continent — from Phesgo to your next four brands.
          </motion.p>
        </div>
      </div>

      {/* Co-brand footer row */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 flex items-center justify-between gap-4" data-id="element-49">
        <div className="flex items-center gap-4" data-id="element-50">
          <span className="text-white/70 text-xs font-semibold uppercase tracking-widest hidden sm:inline" data-id="element-51">
            Proposed by
          </span>
          <div className="bg-white/90 p-2 rounded-lg" data-id="element-52">
            <Logo width={100} data-id="element-53" />
          </div>
        </div>
        <div className="flex items-center gap-3" data-id="element-54">
          <span className="px-4 py-1.5 bg-[var(--brand)] text-white text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-55">
            Roche Ivory Coast
          </span>
          <span className="px-4 py-1.5 bg-white/10 backdrop-blur-md border border-white/20 text-white text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-56">
            Partnering to Deliver
          </span>
        </div>
      </motion.div>
    </div>;
}